import { defineComponent as _defineComponent } from 'vue'
import { useForm } from '@/util/useForm';
import { nextTick, ref, watch } from 'vue';

import { formatDate } from '@/util/global';
import lodash from 'lodash';
import { SELECT_LIST, STATUS_LIST } from './helper';
import { getWarehouseList, initWarehouseData, initOrderData } from '@/api/order/order-management';
import {
  exportOrderList,
  getOrderList,
} from '@/api/order/order-list';
import { message } from 'ant-design-vue';
import ModalItem from '@/component/ModalItem/ModalItem.vue';
import OrderOperation from './components/OrderOperation.vue';
import OrderEditOperation from './components/OrderEditOperation.vue';

import OrderLogistics from './components/OrderLogistics.vue';
import PalatsOrderDetails from './PalatsOrderDetails.vue';
import RefundDetil from '../after-sale/RefundDetil.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PlatformList',
  setup(__props) {

const tableloading = ref<boolean>(false);

const queryParams = ref<any>({ order_status: 0 });
async function exportData() {
  const params = { ...queryParams.value, is_download: 1 };
  const start_time = params.order_time?.[0]
    ? Math.floor(+params.order_time?.[0].format('x') / 1000)
    : '';
  const end_time = params.order_time?.[1]
    ? Math.floor(+params.order_time?.[1].format('x') / 1000)
    : '';
  const query_params = {
    is_download: params?.is_download || undefined,
    number: params.search_type === 1 ? params.search_value : '',
    express_name: params.search_type === 2 ? params.search_value : '',
    express_mobile: params.search_type === 3 ? params.search_value : '',
    express_address: params.search_type === 4 ? params.search_value : '',
    user_id: params.search_type === 5 ? params.search_value : '',
    goods_id: params.goods_id,
    goods_title: params.goods_title,
    warehouse_id: params.warehouse_id === 0 ? '' : params.warehouse_id,
    order_create_start_time: start_time,
    order_create_end_time: end_time,
    pay_type: params.pay_type === 0 ? '' : params.pay_type,
    knight_order_status: params.knight_order_status,
    status: params.order_status === 0 ? '' : params.order_status,
    knight_name: params.knight_name,
    channel: 1,
    current: params?.current || 1,
    total: total.value,
  };
  exportOrderList(query_params);
}

const total = ref<number>(0);
async function query(params = queryParams.value) {
  const start_time = params.order_time?.[0]
    ? Math.floor(+params.order_time?.[0].format('x') / 1000)
    : '';
  const end_time = params.order_time?.[1]
    ? Math.floor(+params.order_time?.[1].format('x') / 1000)
    : '';
  const query_params = {
    is_download: params?.is_download || undefined,
    number: params.search_type === 1 ? params.search_value : '',
    express_name: params.search_type === 2 ? params.search_value : '',
    express_mobile: params.search_type === 3 ? params.search_value : '',
    express_address: params.search_type === 4 ? params.search_value : '',
    user_id: params.search_type === 5 ? params.search_value : '',
    goods_id: params.goods_id,
    goods_title: params.goods_title,
    warehouse_id: params.warehouse_id === 0 ? '' : params.warehouse_id,
    order_create_start_time: start_time,
    order_create_end_time: end_time,
    pay_type: params.pay_type === 0 ? '' : params.pay_type,
    knight_order_status: params.knight_order_status,
    status: params.order_status === 0 ? '' : params.order_status,
    knight_name: params.knight_name,
    channel: 1,
    current: params?.current || 1,
  };

  tableloading.value = true;

  const res: any = await getOrderList(query_params);
  tableloading.value = false;
  total.value = res.total;
  const data = initOrderData(res);
  data.detail.forEach((item, index) => {
    data.detail[index] = {
      ...item,
      level: 0,
      children: [{ ...item, level: 1, id: '1-' + item.id, order_id: item.id }],
    };
  });
  if (data?.detail) {
    dataSource.value = [];
    nextTick(() => {
      dataSource.value = data?.detail;
      pagination.value = {
        total: res?.total,
        current: res?.current,
        pageSize: res?.limit,
        showTotal: () => `共${res.total}条，每页${res.limit}条`,
      };
    });
  } else {
    dataSource.value = [];
    pagination.value = {
      total: res?.total || 1,
      current: 1,
      pageSize: res?.limit || 10,
      showTotal: () => `共${res?.total || 1}条，每页${res?.limit || 10}条`,
    };
  }
}
query();
//检查查询参数变化请求接口刷新数据
watch(
  queryParams,
  (newVal, oldVal) => {
    query(newVal || undefined);
  },
  { immediate: true }
);
const form = useForm();
//表单提交
function submit(e) {
  //移除表单提交默认事件
  e?.preventDefault();
  const formdata = form.value.getFormValue();
  queryParams.value = {
    ...queryParams.value,
    current: 1,
    ...formdata,
  };
}
//重置表单
function clearForm() {
  form.value.resetFields();
  queryParams.value = { current: 1 };
}

const dataSource = ref<any[]>([]);
const pagination = ref<{
  current: number;
  total: number;
  pageSize: number;
  showTotal: () => string;
}>();
function onPagination(page: { current: number; pageSize: number; showTotal: any; total: number }) {
  queryParams.value = {
    ...queryParams.value,
    current: page.current,
  };
}
const warehouse_list = ref();
async function setWarehouseList() {
  const res: any = await getWarehouseList();
  warehouse_list.value = initWarehouseData();
  if (res.status !== 200) {
    message.error(res.message);
    return;
  }
  warehouse_list.value = initWarehouseData(res.data);
  const obj = {
    id: 0,
    name: '全部',
  };
  warehouse_list.value.unshift(obj as any);
}
setWarehouseList();

const columns = ref<any>([]);
//控制table的列
watch(
  [queryParams],
  () => {
    const mustColumns = [
      {
        title: '',
        width: 50,
      },
      {
        title: '商品信息',
        scopedSlots: { customRender: 'goods' },
        width: 300,
      },
      {
        title: '买家/收货人',
        scopedSlots: { customRender: 'buyer' },
        width: 200,
      },
      {
        title: '发货门店',
        scopedSlots: { customRender: 'warehouse' },
        align: 'center',
        width: 150,
      },
    ];
    const mustRightColumns = [
      {
        title: '订单备注',
        scopedSlots: { customRender: 'remark' },
        width: 200,
      },
      {
        title: '订单状态/配送状态',
        scopedSlots: { customRender: 'pay_type' },
        width: 150,
      },
      {
        title: '操作',
        scopedSlots: { customRender: 'operation' },
        width: 150,
        fixed: 'right',
      },
    ];
    const pointsCloumns = [
      {
        title: '积分价格',
        scopedSlots: { customRender: 'points' },
        align: 'center',
        width: 150,
      },
    ];
    const giftCloums = [
      {
        title: '礼券码',
        scopedSlots: { customRender: 'gift_code' },
        align: 'center',
        width: 150,
      },
      {
        title: '商品总价',
        scopedSlots: { customRender: 'goods_cost' },
        align: 'center',
        width: 150,
      },
      {
        title: '优惠金额',
        scopedSlots: { customRender: 'coupon_deduction_amount' },
        align: 'center',
        width: 150,
      },
      {
        title: '实付金额',
        scopedSlots: { customRender: 'total_amount_paid' },
        align: 'center',
        width: 150,
      },
    ];
    columns.value = lodash.cloneDeep(
      [
        ...mustColumns,
        ...(queryParams.value?.pay_type != 5 ? pointsCloumns : []),
        ...(queryParams.value?.pay_type != 4 ? giftCloums : []),
        ...mustRightColumns,
      ].map(item => ({
        ...item,
        customHeaderCell: () => ({
          style: {
            'text-align': 'center',
          },
        }),
      }))
    );
  },
  { immediate: true }
);
const company = ref<string>('');
const numberSF = ref<string>('');

function onStatue(e) {
  queryParams.value = {
    ...queryParams.value,
    order_status: e.target.value,
  };
}

return { __sfc: true,tableloading, queryParams, exportData, total, query, form, submit, clearForm, dataSource, pagination, onPagination, warehouse_list, setWarehouseList, columns, company, numberSF, onStatue, formatDate, SELECT_LIST, STATUS_LIST, ModalItem, OrderOperation, OrderEditOperation, OrderLogistics, PalatsOrderDetails, RefundDetil }
}

})